<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header  bg-primary">
            <div class="card-title">Dashboard การขออนุมัติเกี้ยว {{year_S[0].yearDesc}} </div>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" (click)="LoaddataDashboard();"><i
                  class="fas fa-sync"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                  class="fas fa-minus"></i></button>
            </div>
          </div>

          <div class="card-body table-responsive p-2" style="height: auto">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>กรุณาเลือกปี </mat-label>
              <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="LoaddataDashboard()">
                <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
                <mat-option *ngFor="let item of year_L" [value]=[item]>{{item.yearDesc}}</mat-option>
              </mat-select>
            </mat-form-field>
            <table class="table table-bordered table-hover table-head-fixed text-nowrap">
              <thead>
                <tr class="text-center">
                  <th rowSpan="2"><b>พนักงาน</b></th>
                  <th rowSpan="2"><b>เกี้ยวที่ผ่าน</b></th>
                  <th rowSpan="2" [colSpan]="3"><b>รอรับเรื่อง</b></th>

                  <th rowSpan="2" [colSpan]="3"><b>รับเรื่อง</b></th>
                  <th rowSpan="2" [colSpan]="3"><b>หัวหน้าสินเชื่อ</b></th>
                  <th rowSpan="2" [colSpan]="3"><b>ผู้ช่วย ผจก.สินเชื่อ</b></th>
                  <th rowSpan="2" [colSpan]="3"><b>ผจก.สินเชื่อ</b><br></th>
                  <th rowSpan="2" [colSpan]="3"><b>อนุมัติ</b></th>
                </tr>

              </thead>
              <tbody>
                <tr class="text-center">
                  <td></td>
                  <td></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                  <td><b>(วัน)</b></td>
                  <td><b>(เดือน)</b></td>
                  <td><b>(ทั้งหมด)</b></td>
                </tr>
                <tr class="text-center" *ngFor="let item of datadashboard">
                  <td class="text-left">{{item.fnname}}</td>
                  <td>{{item.cntall|number}}</td>

                  <td>{{item.cntCday|number}}</td>
                  <td>{{item.cntCMonth|number}}</td>
                  <td><u>{{item.cntA|number}}</u></td>

                  <td>{{item.cntCd_s1|number}}</td>
                  <td>{{item.cntCm_s1|number}}</td>
                  <td><u>{{item.cnt1|number}}</u></td>

                  <td>{{item.cntCd_s7|number}}</td>
                  <td>{{item.cntCm_s7|number}}</td>
                  <td><u>{{item.cnt7|number}}</u></td>

                  <td>{{item.cntCd_s8|number}}</td>
                  <td>{{item.cntCm_s8|number}}</td>
                  <td><u>{{item.cnt8|number}}</u></td>

                  <td>{{item.cntCd_s9|number}}</td>
                  <td>{{item.cntCm_s9|number}}</td>
                  <td><u>{{item.cnt9|number}}</u></td>

                  <td>{{item.cntCd_s4|number}}</td>
                  <td>{{item.cntCm_s4|number}}</td>
                  <td><u>{{item.cnt4|number}}</u></td>
                  <!--<td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,managerzonedata);">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCm_s0}}/{{item.cnt0}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-dark progress-bar-striped" role="progressbar" aria-valuemin="0"
                            aria-valuemax="100" aria-valuenow="{{((item.cntCm_s0 * 100) / item.cnt_s0).toFixed(2)}}"
                            [ngStyle]="{width: ((item.cntCm_s0 * 100) / item.cnt_s0).toFixed(2)+'%'}">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>

                  <td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,financedata)">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCd_s1}}/{{item.cntCm_s1}}/{{item.cnt1}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary progress-bar-striped" role="progressbar"
                            [ngStyle]="{width: item.pc_cnt1+'%'}" aria-valuenow="{{item.pc_cnt1}}" aria-valuemin="0"
                            aria-valuemax="100">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>
                  <td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,Hfinancedata)">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCd_s7}}/{{item.cntCm_s7}}/{{item.cnt7}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-danger progress-bar-striped" role="progressbar"
                            [ngStyle]="{width: item.pc_cnt7+'%'}" aria-valuenow="{{item.pc_cnt7}}" aria-valuemin="0"
                            aria-valuemax="100">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>
                  <td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,adjfinancedata)">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCd_s8}}/{{item.cntCm_s8}}/{{item.cnt8}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-danger progress-bar-striped" role="progressbar"
                            [ngStyle]="{width: item.pc_cnt8+'%'}" aria-valuenow="{{item.pc_cnt8}}" aria-valuemin="0"
                            aria-valuemax="100">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>
                  <td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,Mfinancedata)">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCd_s9}}/{{item.cntCm_s9}}/{{item.cnt9}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-yellow progress-bar-striped" role="progressbar" aria-valuemin="0"
                            aria-valuemax="100" aria-valuenow="{{item.pc_cnt9}}" [ngStyle]="{width: item.pc_cnt9+'%'}">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>
                  <td>
                    <i class="fas fa-chalkboard-teacher" (click)="GetDAta(item.fncode,Acceptfinancedata)">
                      <br />
                      <div class="row">
                        <span class="float-right">{{item.cntCd_s4}}/{{item.cntCm_s4}}/{{item.cnt4|number}}</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-success progress-bar-striped" role="progressbar" aria-valuemin="0"
                            aria-valuemax="100" aria-valuenow="{{item.pc_cnt4}}" [ngStyle]="{width: item.pc_cnt4+'%'}">
                          </div>
                        </div>
                      </div>
                    </i>
                  </td>
                -->
                </tr>
                <!--<tr *ngFor="let item of sumall" class="text-center text-bold">
                  <td class="text-left"> <u>++ รวม ++</u> </td>
                  <td class="text-right">{{item.alldata|number}}</td>
                  <td class="text-right">{{item.cntCMonth|number}}</td>
                  <td class="text-right">{{item.cntCday|number}}</td>
                  <td>{{cntCd_s0}}/{{cntCm_s0}}/{{item.allcnt0|number}}</td>
                  <td>{{cntCd_s1}}/{{cntCm_s1}}/{{item.allcnt1|number}}</td>
                  <td>{{cntCd_s7}}/{{cntCm_s7}}/{{item.allcnt7|number}}</td>
                  <td>{{cntCd_s8}}/{{cntCm_s8}}/{{item.allcnt8|number}}</td>
                  <td>{{cntCd_s9}}/{{cntCm_s9}}/{{item.allcnt9|number}}</td>
                  <td>{{cntCd_s4}}/{{cntCm_s4}}/{{item.allcnt4|number}}</td>
                  <td></td>
                </tr>-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card" *ngIf="Alldata ">
          <div class="card-header bg-green">
            <div class="card-title">รายการขอเบิกเกี้ยว {{year_S[0].yearDesc}}</div>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                  class="fas fa-minus"></i></button>
            </div>
          </div>
          <div class="card-body">
            <div class="example-container mat-elevation-z8" #TABLE>
              <mat-form-field appearance="standard">
                <mat-label>ค้นหาเลขที่คำขอ ชื่อชาวไร่ รหัสชาวไร่ </mat-label>
                <input matInput (keyup)="applyFilter2($event)" placeholder="รายการที่ต้องการหา" #input>
              </mat-form-field>

              <mat-table [dataSource]="Alldata" matSort style="width: 100%;">

                <ng-container matColumnDef="num">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                  <td mat-cell *matCellDef="let element; let i = index;">{{i+1 | number}}</td>
                </ng-container>

                <ng-container matColumnDef="timeline">
                  <th mat-header-cell *matHeaderCellDef> Timeline </th>
                  <td mat-cell *matCellDef="let element"> <i class="far fa-clock" (click)="Datainmodel(element.docid)"
                      data-toggle="modal" data-target="#Timeline"></i> </td>
                </ng-container>

                <ng-container matColumnDef="zone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> โซน </th>
                  <td mat-cell *matCellDef="let element"> {{element.SUPZONE}} </td>
                </ng-container>

                <ng-container matColumnDef="docid">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> เลขที่คำขอ </th>
                  <td mat-cell *matCellDef="let element"> {{element.docid}} </td>
                </ng-container>

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> วันที่ </th>
                  <td mat-cell *matCellDef="let element"> {{element.datepost|adtob}} </td>
                </ng-container>

                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> โควตา </th>
                  <td mat-cell *matCellDef="let element"> {{element.fmcode}} </td>
                </ng-container>

                <ng-container matColumnDef="fullname">
                  <th mat-header-cell *matHeaderCellDef> ชื่อ-สกุล </th>
                  <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
                </ng-container>

                <ng-container matColumnDef="titile">
                  <th mat-header-cell *matHeaderCellDef> เรื่องที่ขอ </th>
                  <td mat-cell *matCellDef="let element"> {{element.comment1}} </td>
                </ng-container>

                <ng-container matColumnDef="count">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> จำนวนเงิน </th>
                  <td mat-cell *matCellDef="let element"> {{element.money_amt|number}} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef> สถานะ </th>
                  <td mat-cell *matCellDef="let element"> {{element.docdesc}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displaydatausedall ; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; columns: displaydatausedall;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                </tr>
              </mat-table>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<!-- Modal Timeline -->
<div class="modal fade" id="Timeline" tabindex="-1" role="dialog" aria-labelledby="TimelineLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngFor="let item of datainmodal">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">Timeline เลขที่คำขอ : {{item.docid}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="timeline">
          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-blue"><i class="fas fa-clock"></i> {{THtoLocalstring(item.datepost)}}</span>
          </div>
          <!-- /.timeline-label -->
          <!-- timeline item -->
          <div>
            <i class="fas fa-envelope bg-blue"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-blue">ผู้จัดการโซน - [{{item.sup_U}}]</h3>
              <div class="timeline-body">
                {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
              </div>

            </div>
          </div>
          <!-- END timeline item -->

          <div class="time-label">
            <span class="bg-yellow"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment3date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-comments bg-yellow"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-yellow">พนักงานสินเชื่อ - [{{item.fn_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment3}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-green"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment4date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-green"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-green">หัวหน้าสินเชื่อ - [{{item.head_U}}]</h3>
              <div class="timeline-body">
                |{{item.comment4}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-info"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment5date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-info"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-info">ผู้ช่วย ผจก.สินเชื่อ - [{{item.adj_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment5}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-purple"><i class="fas fa-clock"></i> {{THtoLocalstring(item.dateapprove)}}</span>
          </div>
          <!-- /.timeline-label -->
          <div>
            <i class="fas fa-tasks bg-purple"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-purple">ผจก.สินเชื่อ - [{{item.approve_U}}]</h3>
              <div class="timeline-body">
                | <div *ngIf="item.doc_status =='D'">ไม่อนุมัติ </div> {{item.comment6}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal Timeline -->
<!--  -->
<app-footer></app-footer>